/* LLCL Estrenamos Casa / phase + physical split-flap countdown V2.7 LIVE */
(()=>{'use strict';
const KEY='LLCasaClockManager';
if(window[KEY]){window[KEY].scan(document);return;}
const instances=new Map(),pad=n=>String(Math.max(0,n)).padStart(2,'0');
const reduced=()=>window.matchMedia&&window.matchMedia('(prefers-reduced-motion:reduce)').matches;
function part(side,extra,n){
 const p=document.createElement('span');p.className='ll-casa__flap-part ll-casa__flap-part--'+side+' '+extra;
 const g=document.createElement('span');g.className='ll-casa__flap-glyph';g.textContent=n;p.append(g);return p;
}
function cell(n){
 const e=document.createElement('span');e.className='ll-casa__flap-cell';e.dataset.current=n;e.setAttribute('aria-hidden','true');
 e.append(part('top','flap-static-top',n),part('bottom','flap-static-bottom',n),part('top','ll-casa__flap-fold',n),part('bottom','ll-casa__flap-land',n));
 const hinge=document.createElement('span');hinge.className='ll-casa__flap-hinge';e.append(hinge);return e;
}
function flip(e,n){
 if(e.dataset.current===n)return;
 const old=e.dataset.current||'0';if(e._timer)clearTimeout(e._timer);e.classList.remove('is-flipping');
 const glyphs=e.querySelectorAll('.ll-casa__flap-glyph');
 if(reduced()){glyphs.forEach(g=>g.textContent=n);e.dataset.current=n;return;}
 glyphs[0].textContent=n;glyphs[1].textContent=old;glyphs[2].textContent=old;glyphs[3].textContent=n;
 e.dataset.current=n;void e.offsetWidth;e.classList.add('is-flipping');
 e._timer=setTimeout(()=>{glyphs.forEach(g=>g.textContent=n);e.classList.remove('is-flipping');e._timer=null;},e.closest('[data-casa-mini-board]')?415:510);
}
class Clock{
 constructor(root){
 this.root=root;this.start=Date.parse(root.dataset.casaStart);this.end=Date.parse(root.dataset.casaEnd);
 this.preview=root.dataset.casaPreviewPhase||'auto';this.lang=root.dataset.casaLanguage==='en'?'en':'es';this.epoch=Date.now();this.units={};
 this.mini=root.querySelector('[data-casa-mini-board]');
 this.miniReadout=root.querySelector('[data-casa-mini-readout]');
 this.miniUnits={};
 if(this.miniReadout){
  const fragment=document.createDocumentFragment();
  ['days','hours','minutes','seconds'].forEach((key,index)=>{
   const pair=document.createElement('span');pair.className='ll-casa__mini-pair';
   const numerals=document.createElement('span');numerals.className='ll-casa__mini-digits';
   const digits=[cell('0'),cell('0')];numerals.append(...digits);pair.append(numerals);
   const label=document.createElement('span');label.className='ll-casa__mini-label';
   label.textContent=({days:'D',hours:'H',minutes:'M',seconds:'S'})[key];pair.append(label);
   fragment.append(pair);this.miniUnits[key]={digits};
   if(index<3){
    const sep=document.createElement('span');sep.className='ll-casa__mini-separator';
    sep.textContent=':';fragment.append(sep);
   }
  });
  this.miniReadout.replaceChildren(fragment);
 }
 this.live=root.querySelector('[data-casa-live-compact]');
 this.liveBoard=root.querySelector('[data-casa-live-board]');this.liveUnits={};
 if(this.liveBoard){for(const key of ['days','hours','minutes','seconds']){const host=this.liveBoard.querySelector('[data-casa-live-'+key+']');if(!host)continue;const digits=[cell('0'),cell('0')];host.replaceChildren(...digits);this.liveUnits[key]={digits};}this.liveBoard.classList.add('is-ready');}
 this.accessible=root.querySelector('.ll-casa__clock');this.timer=null;this.minuteLabel=null;
 for(const key of ['days','hours','minutes','seconds']){
 const host=root.querySelector('[data-casa-'+key+']');if(!host)continue;
 const digits=[cell('0'),cell('0')];host.textContent='';host.append(...digits);this.units[key]={host,digits};
 }
 this.tick=this.tick.bind(this);this.tick();
 if(this.phase()!=='ended')this.timer=setInterval(this.tick,1000);
 }
 now(){
 const elapsed=Date.now()-this.epoch;
 if(this.preview==='prelaunch')return Date.parse('2026-10-08T15:00:00-05:00')+elapsed;
 if(this.preview==='live')return Date.parse('2026-10-20T12:00:00-05:00')+elapsed;
 if(this.preview==='ended')return this.end+60000;
 return Date.now();
 }
 phase(){
 if(['prelaunch','live','ended'].includes(this.preview))return this.preview;
 const now=Date.now();return now<this.start?'prelaunch':now<this.end?'live':'ended';
 }
 draw(key,val){
 const group=this.units[key];if(!group)return;
 const numbers=pad(val).slice(-2);[...numbers].forEach((n,i)=>flip(group.digits[i],n));
 group.host.setAttribute('aria-label',numbers);
 }
 drawMini(key,val,animate){
 const group=this.miniUnits[key];if(!group)return;
 const numbers=pad(val).slice(-2);
 [...numbers].forEach((n,i)=>{
  const current=group.digits[i];
  if(animate){flip(current,n);return;}
  if(current.dataset.current===n&&!current.classList.contains('is-flipping'))return;
  if(current._timer)clearTimeout(current._timer);
  current._timer=null;current.classList.remove('is-flipping');
  current.querySelectorAll('.ll-casa__flap-glyph').forEach(g=>g.textContent=n);
  current.dataset.current=n;
 });
 }
 tick(){
 if(!this.root.isConnected){this.destroy();return;}
 if(!Number.isFinite(this.start)||!Number.isFinite(this.end))return;
 const phase=this.phase(),now=this.now(),target=phase==='prelaunch'?this.start:this.end;
 for(const state of ['prelaunch','live','ended'])this.root.classList.toggle('is-'+state,phase===state);
 this.root.dataset.casaPhase=phase;
 const n=Math.max(0,Math.floor((target-now)/1000));
 const d=Math.floor(n/86400),h=Math.floor(n%86400/3600),m=Math.floor(n%3600/60),s=n%60;
 if(phase==='prelaunch'){
 for(const [k,v] of [['days',d],['hours',h],['minutes',m],['seconds',s]])this.draw(k,v);
 const currentMinute=Math.floor(n/60);
 if(this.accessible&&currentMinute!==this.minuteLabel){
 this.accessible.setAttribute('aria-label',this.lang==='en'?('Launch in '+d+' days, '+h+' hours and '+m+' minutes'):('Faltan '+d+' días, '+h+' horas y '+m+' minutos para el lanzamiento'));
 this.minuteLabel=currentMinute;
 }
 }
 if(phase!=='ended'){
  const miniVisible=this.root.classList.contains('is-collapsed');
  for(const [k,v] of [['days',d],['hours',h],['minutes',m],['seconds',s]]){
   this.drawMini(k,v,miniVisible);
  }
  if(this.mini){
   const label=this.lang==='en'?
    ((phase==='prelaunch'?'Launch in ':'Promotion ends in ')+d+' days, '+h+' hours, '+m+' minutes and '+s+' seconds'):
    ((phase==='prelaunch'?'Lanzamiento en ':'La promoción termina en ')+d+' días, '+h+' horas, '+m+' minutos y '+s+' segundos');
   if(this.mini.getAttribute('aria-label')!==label){
    this.mini.setAttribute('aria-label',label);
   }
  }
 }
 const live=phase==='live'?pad(d)+(this.lang==='en'?' DAYS · ':' DÍAS · ')+pad(h)+':'+pad(m)+':'+pad(s):(this.lang==='en'?'CAMPAIGN ENDED':'CAMPAÑA FINALIZADA');
 if(this.live&&this.live.textContent!==live)this.live.textContent=live;
 if(this.liveBoard&&phase==='live'){
  for(const [key,val] of [['days',d],['hours',h],['minutes',m],['seconds',s]]){
   const group=this.liveUnits[key];if(!group)continue;
   [...pad(val).slice(-2)].forEach((num,i)=>flip(group.digits[i],num));
  }
  const label=this.lang==='en'?'Promotion ends in '+d+' days, '+h+' hours, '+m+' minutes and '+s+' seconds':'La promoción termina en '+d+' días, '+h+' horas, '+m+' minutos y '+s+' segundos';
  this.liveBoard.setAttribute('aria-label',label);
 }
 if(phase==='ended')this.stop();
 }
 stop(){if(this.timer)clearInterval(this.timer);this.timer=null;}
 destroy(){this.stop();for(const group of [...Object.values(this.units),...Object.values(this.miniUnits),...Object.values(this.liveUnits)]){for(const digit of group.digits){if(digit._timer)clearTimeout(digit._timer);}}}
}
function scan(context=document){
 for(const [root,instance] of instances){if(!root.isConnected){instance.destroy();instances.delete(root);}}
 const init=root=>{if(!instances.has(root))instances.set(root,new Clock(root));};
 if(context.matches&&context.matches('[data-ll-casa]'))init(context);
 if(context.querySelectorAll)context.querySelectorAll('[data-ll-casa]').forEach(init);
}
function unload(event){for(const [root,instance] of instances){if(event.target===root||event.target.contains(root)){instance.destroy();instances.delete(root);}}}
document.addEventListener('shopify:section:load',e=>scan(e.target));
document.addEventListener('shopify:section:unload',unload);
window[KEY]={version:'2.6-mini-splitflap',scan};
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>scan(document),{once:true});else scan();
})();